import { privateApi } from "@core/libs/axios";
import { handleResponse } from "@core/libs/axios/serviceHandler";
import type { TChangePwdSchema } from "@core/types";

export async function changePassword(
  payload: TChangePwdSchema,
  signal?: AbortSignal,
  invalidate_sessions: boolean = false,
): Promise<void> {
  await handleResponse<void>(
    privateApi.post("/user/reset-password", payload, {
      signal,
      params: {
        invalidate_sessions,
      },
    }),
  );
}
